/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex, Text } from '@radix-ui/themes';

import Section from 'solis/claude/primitive/section';

import ScoreRow from 'solis/claude/score/row';


export default ({ label, scores, user }) =>
{
  const self = scores.find(entry => entry.user === user);

  return (
    <Card>
      <Section label = {label}>
        <Text size = '6' weight = 'bold'>{'#' + self.rank}</Text>

        <Flex direction = 'column' gap = '1'>
          {scores.map(entry => <ScoreRow key = {entry.user} entry = {entry} highlight = {entry.user === user} />)}
        </Flex>
      </Section>
    </Card>
  );
};
